//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
const MdmModal = () => import(
/* webpackChunkName: "modal" */
'~/components/atoms/Global/MdmModal.vue');

export default {
  name: 'YoutubeModal',
  components: {
    MdmModal
  },
  props: {
    showYoutubeModal: {
      type: Boolean,
      required: false
    },
    src: {
      type: Array,
      required: true
    }
  }
};